export const SERVICES = [
  "Accounting and Auditing", "Agriculture & Farming", "Air Conditioning",
  "Air Conditioning & Refrigeration (HVAC)", "Architecture & Built Environment",
  "Bearings and Bushings", "Bolts & Nuts", "Building Maintenance & Facilities",
  "Car Wash", "Catering", "Catering & Deco", "Catering & Hospitality",
  "Cleaning & Hygiene", "Cleaning Equipment & Supplies", "Cleaning Services",
  "Computer Equipment", "Construction & Civil Works", "Consulting Engineers",
  "Conveyor Belt Manufacturing", "Drilling", "Drilling & Blasting", "Dust Suppression",
  "Earthmoving & Excavation", "Electrical Engineering", "Electrical Engineering Supplies",
  "Electrical Supplies & Installations", "Electronics", "Employees Transport",
  "Energy & Renewables", "Engineering (Chemical / Metallurgical)", "Engineering (Civil)",
  "Engineering (Electrical)", "Engineering (Mechanical)", "Engineering Services",
  "Environmental & Rehabilitation Services", "Financial Services & Accounting",
  "Fire Protection Services", "Fuel & Lubricants", "Fuel Supply", "Gardening Services",
  "Gas Supply", "General Mining Supplies", "Geological & Surveying Services",
  "HR, Recruitment & Labour Broking", "Health, Safety & Environment (SHEQ)",
  "Healthcare & Medical Services", "Hydraulics", "ICT & Technology",
  "Industrial Laundry & Dry-Cleaning Equipment", "Information Technology",
  "Insurance & Risk Management", "Landscaping & Grounds Maintenance", "Laundry Services",
  "Legal Services", "Logistics & Transport (Freight)", "Logistics & Transport (Passenger)",
  "Manufacturing", "Marketing, Advertising & Branding", "Mine Dump Management",
  "Mining Equipment & Spares", "Mining Heavy Machinery Supplies", "Mining Services",
  "Office Equipment & Accessories", "Office Supplies & Stationery", "Oil & Lubricants Supply",
  "PPE & Safety Equipment", "Painting & Decorating", "Pest Control",
  "Pharmaceuticals & Medical Supplies", "Plant Hire", "Plant Hire & Heavy Equipment",
  "Plumbing", "Printing, Signage & Promotional", "Professional Services (Consulting)",
  "Protective Clothing", "Purification & Ablution Services", "Refuse Disposal",
  "Roads, Paving & Asphalt", "SHEQ Consultant", "Sanitation Services",
  "Scrap and Waste Material", "Security & Surveillance", "Security Services",
  "Side Tipper Trucks", "Stationery", "Steel & Metal Supply", "Steelworks",
  "Structural Engineering", "Supply Hoses", "Supply Mining Equipment & Consumables",
  "Surveying, Mapping & GIS", "Sweeping & Vamping", "Telecommunications",
  "Tools, Hardware & Industrial Supplies", "Training & Skills Development",
  "Underground Cleaning", "Vending Machines", "Waste Management", "Water & Sanitation",
  "Water Supply", "Welding & Fabrication",
];

export const PROVINCES = ["North West", "Gauteng", "Northern Cape"];

export const TOWNS = [
  "Letsopa", "Gestoptefontein", "Korannafontein", "Rietkuil", "Nkandla Village",
  "Delareyville", "Ottosdal", "Sannieshof", "Klerksdorp", "Vryburg", "Phatsima B",
  "Pomfret", "Potchefstroom", "Schweizer-Reneke", "Stella (Rekgaritlhile)",
  "Stilfontein (Khuma)", "Sun City", "Sun Village", "Swartruggens (Borolelo)",
  "Umzimhle (Vaal Reefs)", "Ventersdorp (Tshing)", "Vryburg (Huhudi)",
  "Witpoort (Rulaganyang)", "Wolmaransstad (Tswelelang)", "Zeerust (Ikagele)",
];
